'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tlOnFieldChange', function (fieldUtils) {
  return {
    restrict: "A",
    scope: {
      'tlOnFieldChange': "&"
    },
    link: function link($scope, $el, $attrs) {
      fieldUtils.delegateFieldChange($el, function () {
        $scope.tlOnFieldChange();
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlOnFieldChange.js
// module id = 2908
// module chunks = 13